// extracted by css-extract-rspack-plugin
export default {"cls1":"OnboardingTour-cls1_wBj","cls2":"OnboardingTour-cls2_ztU OnboardingTour-cls1_wBj"};